<form [formGroup]="investForm" [ngClass]="{error: isError}">
    <!-- <mat-form-field *ngIf="mode === indiceMode.amount">
        <input matInput appAutofocus type="text" name="amount"
        [value]="investForm.get('amount').value | formatAmount: 'rounded': false "
        onclick="this.select()"
        formControlName="amount">
        <span matSuffix> €</span>
    </mat-form-field> -->
    <mat-form-field *ngIf="mode === indiceMode.amount">
        <input matInput type="text" name="amount" formControlName="amount"
        (focus)="onShowValue()" (blur)="onEmitValue()" onclick="this.select()">
        <span matSuffix> €</span>
    </mat-form-field>

    <mat-form-field *ngIf="mode === indiceMode.percent">
        <input matInput appAutofocus type="number" inputmode="numeric" name="indice"
        onclick="this.select()"
        formControlName="indice">
        <span matSuffix> %</span>
    </mat-form-field>
</form>

